import {mergeStyleSets, Theme} from "@fluentui/react";

export const createStyles = (theme: Theme) => mergeStyleSets({
  conditionEditor: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 12px 0 12px',
    '& .delete-button': {
      height: '16px'
    }
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '12px',
  },
  joinOperatorPanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.semanticColors.disabledBackground,
    height: '56px',
    padding: '0 12px',
  }
})